<template>
  <v-layout justify-center wrap>
    <v-flex text-center>
      <v-sheet class="py-4 px-1">
        <v-chip-group center-active show-arrows>
          <v-chip
            v-for="(item, i) in blogCategories"
            :key="i"
            color="#1D1C1C"
            @click="SelectedItem(item)"
          >
            <span
              style="
                font-family: poppinssemibold;
                font-size: 12px;
                color: #ffffff;
                letter-spacing: 2px;
              "
            >
              {{ item.name }}
            </span>
          </v-chip>
               <v-chip
            color="#1D1C1C"
            @click="SelectedItem('all')"
          >
            <span
              style="
                font-family: poppinssemibold;
                font-size: 12px;
                color: #ffffff;
                letter-spacing: 2px;
              "
            >
              All
            </span>
          </v-chip>
        </v-chip-group>
      </v-sheet>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      blogCategories: [],
    };
  },
  beforeMount() {
    this.getBlogCategory();
  },
  methods: {
    getBlogCategory() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/home/newblog/category/getlist",
        params: {
          mainCategoryId: this.$route.query.category,
          styl: this.$route.query.styl,
        },
      })
        .then((reponse) => {
          this.appLoading = false;
          this.blogCategories = reponse.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    SelectedItem(item) {
      this.$emit("stepper", {
        type: "blogCategory",
        pageResponse: item,
      });
    },
  },
};
</script>